import { IconButton, IconButtonProps } from '@material-ui/core';
import Edit from '@material-ui/icons/Edit';

export const EditButton = (props: IconButtonProps) => {
  return (
    <IconButton
      size={props.size}
      aria-label="Edit"
      data-track-id="button.edit"
      data-track-action="open-dialog"
      {...props}
    >
      <Edit fontSize={props.size} />
    </IconButton>
  );
};
